import React from 'react';
import { Check } from 'lucide-react';
import { IconPackageExport } from '@tabler/icons-react';

const RESERVA_TOOLTIP =
  'Reserva automática ativa — ao gerar pedido neste status, o item é reservado automaticamente.';

function isReservaAtiva(row, fieldKey) {
  if (fieldKey === 'status_disponivel') {
    return row.func_order_st_available_res === 1 || row.func_order_st_available_res === true;
  }
  return row.func_order_st_unavailable_res === 1 || row.func_order_st_unavailable_res === true;
}

export function Ci2ReservarCheck({ row, fieldKey, api, variant = 'inline' }) {
  const { reserveSavingKey, patchStatusReserve } = api;
  const isAvailable = fieldKey === 'status_disponivel';
  const checked = isReservaAtiva(row, fieldKey);
  const reserveTitle = 'Ao gerar pedido neste status, automaticamente é reservado.';
  const stopBubble = (e) => e.stopPropagation();
  const onToggle = (e) =>
    patchStatusReserve(row, isAvailable ? 'available' : 'unavailable', e.target.checked);

  if (variant === 'in-input') {
    return (
      <label
        className="ci2-reserva-check-label ci2-reserva-check-label--in-input"
        title={reserveTitle}
        onClick={stopBubble}
        onMouseDown={stopBubble}
      >
        <input
          type="checkbox"
          className="ci2-reserva-check-native"
          checked={checked}
          disabled={reserveSavingKey != null}
          onChange={onToggle}
        />
        <span className="ci2-reserva-check-box" aria-hidden />
        <span className="ci2-reserva-check-text">Reservar</span>
      </label>
    );
  }

  const className =
    variant === 'popover'
      ? 'ci2-check-label ci2-check-label--popover'
      : 'ci2-check-label';

  return (
    <label className={className} title={reserveTitle} onClick={stopBubble} onMouseDown={stopBubble}>
      <input
        type="checkbox"
        className="ci2-check-native"
        checked={checked}
        disabled={reserveSavingKey != null}
        onChange={onToggle}
      />
      <span className={`ci2-check-box${checked ? ' on' : ''}`} aria-hidden="true">
        <Check size={10} strokeWidth={3} />
      </span>
      <span className={`ci2-check-text${checked ? ' on' : ''}`}>Reservar</span>
    </label>
  );
}

export function Ci2ReservaIndicador({ row, fieldKey }) {
  if (!isReservaAtiva(row, fieldKey)) return null;

  return (
    <span
      className="ci2-reserva-tip condicoes-hover-tooltip-host"
      data-tooltip={RESERVA_TOOLTIP}
      aria-label={RESERVA_TOOLTIP}
    >
      <IconPackageExport size={16} stroke={1.75} className="ci2-reserva-icon" aria-hidden />
    </span>
  );
}
